/**
 * @项目名称: work
 * @功能名称: 解决历史后台从cookie中获取openId、applyId、couponSource 但是注册登录迁移支付后无法获取的问题
 * @文件名称: cookieKeyword
 * @Date: 2020/4/24
 * @Author: liux
 * @Copyright（C）2020 「小赢科技」 Inc.   All rights reserved.
 * 注意：本内容仅限于「小赢科技」内部传阅，禁止外泄以及用于其他的商业目的。
 */

import cookie from 'bjxy-common/helper/cookie'

var result ={
  couponSource: cookie.get('couponSource'),
  applyId: cookie.get('applyId')
}
// 应后台要求将session_key_** 拆成两部分
var m = document.cookie.match(/session_key_(.+?)=(.+?)(;|$)/i);
if(m){
  result.accountKey = m[1];
  result.sessionKey = m[2];
}

export default result
